export default "<img src=\"https://hotspot-wizard.sirv.com/pointers/pointer1/plus.svg\" />\n";